import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from "react-router";
import { Card, Button, Modal, Form, Upload, Input, Select, Icon, Spin, message } from "antd";
import _ from "lodash";

import ContentForm from "./../itemHelper/contentForm";
import AdsForm from "./../itemHelper/adsForm";
import BannersForm from "./../itemHelper/bannersForm";
import ShareForm from "./../itemHelper/shareForm";
import AdsenseForm from "./../itemHelper/adsenseForm";
import PrintableForm from "./../itemHelper/printableForm";
import ContentsForm from "./../itemHelper/contentsForm";
import ArticleForm from "./../itemHelper/articleForm";
import TeaserForm from "./../itemHelper/teaserForm";

import Services from "../../../services/item";
import ItemFormHelper from "./ItemFormHelper";

const ItemForm = (props) => {

  const { shareData } = useSelector(
    ({ share }) => share
  );

  const { adsenseData } = useSelector(
    ({ adsense }) => adsense
  );

  const history = useHistory();

  const { TextArea } = Input;
  const Option = Select.Option;
  const FormItem = Form.Item;

  let PreviewFromLink = {
    uid: "",
    name: "",
    status: "done",
    response: "ok",
    url: "",
  };

  const [categoryName, setCategoryName] = useState("");
  const [systemName, setSystemName] = useState("");
  const [parentCategory, setParentCategory] = useState(true);
  const [slug, setSlug] = useState("");
  const [keywords, setKeywords] = useState("");
  const [title, setTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [shortDescription, setShortDescription] = useState("");

  const [selectedParent, setSelectedParent] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [contentForEdit, setContentForEdit] = useState([]);
  const [isSave, setIsSave] = useState(false);

  const [previewImage, setPreviewImage] = useState(null);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [image, setImage] = useState("");
  const [fileList, setFileList] = useState([]);

  const [contentProps, setContentProps] = useState([]);
  const [adsProps, setAdsProps] = useState([]);
  const [bannersProps, setBannersProps] = useState([]);
  const [shareProps, setShareProps] = useState([]);
  const [adsenseProps, setAdsenseProps] = useState([]);
  const [printableProps, setPrintableProps] = useState([]);
  const [articleProps, setArticleProps] = useState([]);
  const [teaserProps, setTeaserProps] = useState([]);


  useEffect(() => {
    getInitialData();
  }, []);

  const getInitialData = async () => {
    setLoading(true);

    const { match } = props;
    let { id } = match.params;

    const categories = await Services.getAllCategoryList();
    const categoryList = categories
      ?.map((item) => ({
        level: item.level,
        name: item.name,
        slug: item.slug,
        _id: item._id,
      }))
    // .filter((item) => item.level <= 2 && id !== item._id);

    if (id) {
      const details = await Services.getItemDetails(id);

      const parent = details?.data?.category;
      if (parent) {
        let parentArr = [];
        let indexArr = [];

        for (let i = 0; i < parent.length; i++) {
          let parentIndex = categoryList.findIndex(
            (category) => category._id === parent[i]
          );

          if (parentIndex !== -1) {
            parentArr.push(categoryList[parentIndex]);
            indexArr.push(parentIndex)
          }
        }

        setSelectedParent(parentArr);
        setParentCategory(indexArr);
      }

      setCategoryName(details?.data?.name);
      setSystemName(details?.data?.stringId);
      setSlug(details?.data?.slug);
      setKeywords(details?.data?.metaKeywords);
      setTitle(details?.data?.metaTitle);
      setMetaDescription(details?.data?.metaDescription);
      setShortDescription(details?.data?.shortDescription);
      setImage(details?.data?.image);
      setFileList(details?.data?.image
        ? [
          {
            ...PreviewFromLink,
            uid: details?.data?.image,
            name: "",
            url: `/api/util/image?key=${details?.data?.image}`,
          },
        ]
        : []);

      setIsEdit(true);
      setIsSave(details?.data?.slug ? true : false);

      setContentForEdit(details?.data?.section);

      let content = details.data.section.filter(element => element.type == "html") || [];
      let ads = details.data.section.filter(element => element.type == "ads") || [];
      let banners = details.data.section.filter(element => element.type == "banners") || [];
      let share = details.data.section.filter(element => element.type == "share") || [];
      let adsense = details.data.section.filter(element => element.type == "adsense") || [];
      let printable = details.data.section.filter(element => element.type == "printable") || [];
      let articles = details.data.section.filter(element => element.type == "article") || [];
      let teasers = details.data.section.filter(element => element.type == "teaser") || [];

      setContentProps(content);
      setAdsProps(ads);
      setBannersProps(banners);
      setShareProps(share);
      setAdsenseProps(adsense);
      setPrintableProps(printable);
      setArticleProps(articles);
      setTeaserProps(teasers);
    }

    setCategoryList(categoryList);

    setLoading(false);
  }

  const handleCategoryName = (e) => {
    let slug = e.target.value.replace(/[^A-Za-z0-9-]/gi, "").toLowerCase();

    setSlug(slug);
    setCategoryName(e.target.value);
  };

  const handleSystemName = (e) => {
    setSystemName(e.target.value);
  };

  const handleSlug = (e) => {
    let slug = e.target.value.replace(/[^A-Za-z0-9-]/gi, "").toLowerCase();

    setSlug(slug);
  };

  const handleShortDescription = (e) => {
    setShortDescription(e.target.value);
  };

  const handleKeywords = (e) => {
    setKeywords(e.target.value);
  };

  const handleTitle = (e) => {
    setTitle(e.target.value);
  };

  const handleMetaDescription = (e) => {
    setMetaDescription(e.target.value);
  };

  // const handleISActive = (val) => {
  //   setIsActive(val);
  // };

  const handleParentCategory = (val) => {
    setParentCategory(val);
    let multiParent = [];
    for (let i = 0; i < val.length; i++) {
      multiParent.push(categoryList[val[i]])
    }
    setSelectedParent(multiParent);
  };

  const handlePreview = (file) => {
    setPreviewImage(file.url || file.thumbUrl);
    setPreviewVisible(true);
  };

  const handleCancel = () => setPreviewVisible(false);

  const customRequest = async ({ file, onSuccess }) => {
    setImage(file);
    setTimeout(() => onSuccess("ok"), 0);
  };

  const handleChange = ({ file, fileList }) => {
    setFileList(fileList)
  };

  const handleRemove = () => {
    setImage([]);
  };

  const onPreview = () => {
    const url = `https://www.onlineworksheetsforkids.com/${slug}`
    isSave && window.open(url, '_blank');
  }

  const getArticle = async () => {
    let articleArray = [];

    const articleState = ItemFormHelper.getArticleState();
    console.log(articleState);

    if (articleState) {
      const UploadedArticle = await Promise.all(
        articleState.article?.fields?.map(async (item, index) => {
          if (!articleState?.images[index]) {
            return {
              _id: articleState.article?._id[index],
              title: articleState.article?.title[index],
              description: articleState.article?.description[index],
              sortNo: articleState.article?.sortNo[index]
            };
          }

          let file = articleState?.images[index];
          let response;

          if (!!file) {
            response = await Services.uploadToS3({ file: file });
            Promise.resolve(response);
          }

          return {
            fileName: response?.fileName,
            originalName: response?.originalName,
            title: articleState.article?.title[index],
            description: articleState.article?.description[index],
            _id: articleState.article?._id[index],
            sortNo: articleState.article?.sortNo[index]
          };
        })
      );

      console.log(UploadedArticle);

      for (let i = 0; i < UploadedArticle.length; i++) {
        if (UploadedArticle[i] !== undefined) {
          if (UploadedArticle[i]?._id) {
            articleArray.push({
              type: "article",
              article: {
                _id: UploadedArticle[i]._id,
                title: UploadedArticle[i].title,
                description: UploadedArticle[i].description
              },
              sort: UploadedArticle[i].sortNo
            });
          } else {
            articleArray.push({
              type: "article",
              article: {
                fileName: UploadedArticle[i].fileName,
                originalName: UploadedArticle[i].originalName,
                title: UploadedArticle[i].title,
                description: UploadedArticle[i].description
              },
              sort: UploadedArticle[i].sortNo
            });
          }
        }
      }
    }

    let outObject = articleArray.reduce(function (a, e) {
      let estKey = (e['sort']);

      (a[estKey] ? a[estKey] : (a[estKey] = null || [])).push(e);
      return a;
    }, {});

    console.log(outObject);

    let allArticleItem = [];
    for (const property in outObject) {
      let innerArr = outObject[property];
      let onlyArticle = [];

      for (let k = 0; k < innerArr.length; k++) {
        onlyArticle.push(innerArr[k].article)
      }

      allArticleItem.push({
        article: onlyArticle,
        sort: innerArr[0].sort,
        type: "article"
      })
    }

    return allArticleItem;
  }

  const getTeaser = async () => {
    let teaser = [];

    const teaserState = ItemFormHelper.getTeaserState();
    console.log(teaserState);

    if (teaserState) {
      const UploadedTeaser = await Promise.all(
        teaserState.teaser?.fields?.map(async (item, index) => {

          if (!teaserState?.images[index]) {
            return {
              _id: teaserState.teaser?._id[index],
              title: teaserState.teaser?.title[index]
            }
          }

          let file = teaserState?.images[index];
          let response;

          if (!!file) {
            response = await Services.uploadToS3({ file: file });
            Promise.resolve(response);
          }

          return {
            fileName: response?.fileName,
            originalName: response?.originalName,
            title: teaserState.teaser?.title[index],
            _id: teaserState.teaser?._id[index],
          };
        })
      );

      teaser.push({
        type: "teaser",
        teaser: UploadedTeaser,
        sort: teaserState.sortNo,
        heading: teaserState.heading,
        subHeading: teaserState.subHeading,
        bulletTextOne: teaserState.bulletTextOne,
        bulletTextTwo: teaserState.bulletTextTwo,
        bulletTextThree: teaserState.bulletTextThree,
        bulletTextFour: teaserState.bulletTextFour
      });

    }

    return teaser;
  }

  const onSubmit = async () => {
    
    setLoading(true);

    if (slug && slug.length <= 2) {
      message.warning("Slug must be more than 2 characters");
      setLoading(false);
      return;
    }

    if (
      !categoryName ||
      !systemName ||
      // !selectedParent ||
      !slug ||
      !keywords ||
      !title ||
      !metaDescription
    ) {
      message.error("Please insert all required fields");
      setLoading(false);
      return;
    }

    //Thumbnail image
    let thumbIMG = {};
    if (image && typeof image == "object") {
      thumbIMG = await Services.uploadToS3({ file: image });
      Promise.resolve(thumbIMG);
    } else {
      thumbIMG["fileName"] = image;
    }

    let section = [];
    let ads = [];
    let printable = [];
    let banners = [];
    let bannersArray = [];

    const multiBannerState = ItemFormHelper.getMultiBannerState();

    const contentState = ItemFormHelper.getContentState().content;
    const adsState = ItemFormHelper.getAdsState();
    const printableState = ItemFormHelper.getPrintableState();

    //-------------ads section-------------
    if (adsState) {
      const uploadedAds = await Promise.all(
        adsState.ad?.fields?.map(async (item, index) => {
          if (!adsState?.images[index]) {
            return {
              fileName: adsState.ad?.fileName[index],
              originalName: adsState.ad?.originalName[index],
              sortNo: adsState.ad?.sortNo[index]
            };
          }

          let file = adsState?.images[index];
          let response;

          if (!!file) {
            response = await Services.uploadToS3({ file: file });
            Promise.resolve(response);
          }
          return {
            fileName: response?.fileName,
            originalName: response?.originalName,
            sortNo: adsState.ad?.sortNo[index],
            // fileName: adsState.ad?.fileName[index],
          };
        })
      );

      for (let i = 0; i < uploadedAds.length; i++) {

        if (uploadedAds[i] !== undefined) {
          ads.push({
            type: "ads",
            ads: {
              fileName: uploadedAds[i].fileName,
              originalName: uploadedAds[i].originalName
            },
            sort: uploadedAds[i].sortNo
          });
        }
      }

      section = [...contentState, ...ads];
    }

    //---------------Printable section--------------
    if (printableState) {
      const UploadedPrintable = await Promise.all(
        printableState.printable?.fields?.map(async (item, index) => {

          if (!printableState?.images[index] && !printableState?.pdf[index] && !printableState?.solutionPdf[index]) {
            return {
              _id: printableState.printable?._id[index],
              title: printableState.printable?.title[index],
              description: printableState.printable?.description[index],
            };
          }

          let file = printableState?.images[index];
          let response;

          if (!!file) {
            response = await Services.uploadToS3({ file: file });
            Promise.resolve(response);
          }

          let pdfFile = printableState?.pdf[index];
          let pdfResponse;

          if (!!pdfFile) {
            pdfResponse = await Services.uploadToS3({ file: pdfFile });
            Promise.resolve(pdfResponse);
          }

          let solutionPdfFile = printableState?.solutionPdf[index];
          let solutionPdfResponse;

          if (!!solutionPdfFile) {
            solutionPdfResponse = await Services.uploadToS3({ file: solutionPdfFile });
            Promise.resolve(solutionPdfResponse);
          }

          return {
            pdfFileName: pdfResponse?.fileName,
            pdfOriginalName: pdfResponse?.originalName,
            solutionPdfFileName: solutionPdfResponse?.fileName,
            fileName: response?.fileName,
            originalName: response?.originalName,
            title: printableState.printable?.title[index],
            description: printableState.printable?.description[index],
            pdfUrl: printableState.printable?.pdfUrl[index],
            _id: printableState.printable?._id[index],
          };
        })
      );

      printable.push({
        type: "printable",
        printable: UploadedPrintable,
        sort: printableState.sortNo
      });

      section = [...section, ...printable];
    }

    //---------------adsense this section--------------
    const adsenseThisState = adsenseData;
    let adsense = [];
    console.log("adsense: ", adsenseThisState);
    if (adsenseThisState && adsenseThisState.sortNo && adsenseThisState.sortNo.length) {

      for (let a = 0; a < adsenseThisState.sortNo.length; a++) {
        adsense.push({
          type: "adsense",
          // adsense: adsenseThisState.isAdsense[a],
          sort: adsenseThisState.sortNo[a]
        })
      }

      section = [...section, ...adsense];
    }

    //---------------share this section--------------
    const shareThisState = shareData;
    let share = [];
    console.log("share: ", shareThisState);
    if (shareThisState && shareThisState.sortNo && shareThisState.sortNo.length) {

      for (let z = 0; z < shareThisState.sortNo.length; z++) {
        share.push({
          type: "share",
          // share: shareThisState.isShare[z],
          sort: shareThisState.sortNo[z]
        })
      }

      section = [...section, ...share];
    }

    //--------------Banner section---------------
    const bannersState = ItemFormHelper.getBannersState();

    if (bannersState) {
      const UploadedBannner = await Promise.all(
        bannersState.banner?.fields?.map(async (item, index) => {
          if (!bannersState?.images[index]) {
            return {
              _id: bannersState.banner?._id[index],
              title: bannersState.banner?.title[index],
              url: bannersState.banner?.url[index],
              sortNo: bannersState.banner?.sortNo[index]
            };
          }

          let file = bannersState?.images[index];
          let response;

          if (!!file) {
            response = await Services.uploadToS3({ file: file });
            Promise.resolve(response);
          }

          return {
            fileName: response?.fileName,
            originalName: response?.originalName,
            title: bannersState.banner?.title[index],
            url: bannersState.banner?.url[index],
            _id: bannersState.banner?._id[index],
            sortNo: bannersState.banner?.sortNo[index]
          };
        })
      );

      for (let i = 0; i < UploadedBannner.length; i++) {
        if (UploadedBannner[i] !== undefined) {
          if (UploadedBannner[i]?._id) {
            bannersArray.push({
              type: "banners",
              banners: {
                _id: UploadedBannner[i]._id,
                title: UploadedBannner[i].title,
                url: UploadedBannner[i].url
              },
              sort: UploadedBannner[i].sortNo
            });
          } else {
            bannersArray.push({
              type: "banners",
              banners: {
                fileName: UploadedBannner[i].fileName,
                originalName: UploadedBannner[i].originalName,
                title: UploadedBannner[i].title,
                url: UploadedBannner[i].url
              },
              sort: UploadedBannner[i].sortNo
            });
          }
        }
      }
    }

    let outObject = bannersArray.reduce(function (a, e) {
      let estKey = (e['sort']);

      (a[estKey] ? a[estKey] : (a[estKey] = null || [])).push(e);
      return a;
    }, {});

    let allBannersItem = [];
    for (const property in outObject) {
      let innerArr = outObject[property];
      let onlyBanner = [];

      for (let k = 0; k < innerArr.length; k++) {
        onlyBanner.push(innerArr[k].banners)
      }

      allBannersItem.push({
        banners: onlyBanner,
        sort: innerArr[0].sort,
        type: "banners"
      })
    }

    section = [...section, ...allBannersItem];
    //------------------------

    //---------------Article section---------------
    const articles = await getArticle();
    section = [...section, ...articles];
    //---------------------------------------------

    //---------------Teaser section---------------
    const teaser = await getTeaser();
    section = [...section, ...teaser];
    //---------------------------------------------

    if (multiBannerState) {

      const key = 'sortNo';
      const uniqueBannerbySort = [...new Map(multiBannerState.map(item =>
        [item[key], item])).values()];

      console.log(uniqueBannerbySort);

      for (let i = 0; i < multiBannerState.length; i++) {


        const UploadedBannner = await Promise.all(
          multiBannerState[i].banner?.fields?.map(async (item, index) => {
            if (!multiBannerState[i]?.images[index]) {
              return {
                _id: multiBannerState[i].banner?._id[index],
                title: multiBannerState[i].banner?.title[index],
                url: multiBannerState[i].banner?.url[index],
              };
            }

            let file = multiBannerState[i]?.images[index];
            let response;

            if (!!file) {
              response = await Services.uploadToS3({ file: file });
              Promise.resolve(response);
            }

            return {
              fileName: response?.fileName,
              originalName: response?.originalName,
              title: multiBannerState[i].banner?.title[index],
              url: multiBannerState[i].banner?.url[index],
              _id: multiBannerState[i].banner?._id[index],
              sortNo: multiBannerState[i].sortNo
            };
          })
        );

        console.log(UploadedBannner);
        banners.push({
          type: "banners",
          banners: UploadedBannner,
          sort: UploadedBannner[0].sortNo
        });
      }

      section = [...section, ...banners];
    }

    const { match } = props;

    let { id } = match.params;

    if (isEdit && !id) {
      message.error("Item id is missing");
      return;
    }

    let categoryResponse;
    try {
      if (!isEdit) {
        categoryResponse = await Services.addItem({
          categoryName,
          systemName,
          category: selectedParent,
          slug,
          keywords,
          title,
          description: metaDescription,
          shortDescription,
          image: thumbIMG?.fileName,
          section
        });

        history.push(`/itemEditForm/${categoryResponse.data._id}`);
        window.location.reload(false);
        setIsEdit(true);
      } else {

        categoryResponse = await Services.editItem({
          itemId: id,
          categoryName,
          systemName,
          category: selectedParent,
          slug,
          keywords,
          title,
          description: metaDescription,
          shortDescription,
          image: thumbIMG?.fileName,
          section
        });
      }
    } catch (e) {
      if (!image) {
        message.error(e.response.data.message);
      } else {
        message.error(e.response.data.error.message);
      }
      console.error("Error", e);
    }

    if (categoryResponse?.status == 200) {
      setLoading(false);
      message.success("Saved!");
      setIsSave(true);
      window.location.href = "/item";
    } else {
      setLoading(false);
    }
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  const children = [];
  for (let i = 1; i < 10; i++) {
    children.push(<Option key={i.toString(36) + i}>{"test"}</Option>);
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text"><span style={{ color: "red" }}>*</span>Upload</div>
    </div>
  );

  return (
    <Spin spinning={loading} size="large">
      <div className="menu-editor-box card-pad-new menu-cate-list users-main-page categoryForm-main">
        <div className="payout-report-box">
          <Card className="gx-card breadcrumb-box" title="">
            <div className="ant-row hd-title">
              <div className="ant-col-md-12">
                <h1>Manage Item</h1>
              </div>
              <div className="ant-col-md-12 rite-btn d-none">
                <Button type="primary" className="color-white">
                  {" "}
                  Create
                </Button>
              </div>
              {/* <div className="ant-col-md-12">
                <div className="orders-item top-section filter-box ">
                  <div className="drop-filter-cover">
                    <Select
                      className="select-box"
                      defaultValue={"Select"}
                      value={isActive}
                      onChange={handleISActive}
                    >
                      <Option value={true}> Enabled</Option>
                      <Option value={false}>Disabled</Option>
                    </Select>
                  </div>
                </div>
              </div> */}
            </div>
            <div className="ant-row gx-mt-4">
              <div className="ant-col-md-24">
                <div className="item-detail-edit-box">
                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Name</span>}
                      >
                        <Input
                          type="text"
                          placeholder="Category Name"
                          value={categoryName}
                          onChange={handleCategoryName}
                        />
                      </FormItem>
                    </div>

                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Item System Name</span>}
                      >
                        <Input
                          type="text"
                          placeholder="Item System Name"
                          value={systemName}
                          onChange={handleSystemName}
                        />
                      </FormItem>
                    </div>

                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label="Category"
                      >
                        <Select
                          value={parentCategory}
                          mode="multiple"
                          placeholder="Category"
                          optionFilterProp="children"
                          onChange={handleParentCategory}
                          showSearch
                          filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                          <Option value={true}>{"No Parent"}</Option>
                          {categoryList.map((item, i) => {
                            return (
                              <Option key={i} value={i}>
                                {item.name}
                              </Option>
                            );
                          })}
                        </Select>
                      </FormItem>
                    </div>

                  </div>
                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Slug/URL</span>}

                      >
                        <Input
                          type="text"
                          placeholder="Slug/URL"
                          onChange={handleSlug}
                          value={slug}
                        />
                      </FormItem>
                    </div>

                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Meta Keywords</span>}
                      >
                        <Input
                          type="text"
                          placeholder="Meta Keywords"
                          onChange={handleKeywords}
                          value={keywords}
                        />
                      </FormItem>
                    </div>

                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Meta Title</span>}
                      >
                        <Input
                          type="text"
                          placeholder="Meta Title"
                          onChange={handleTitle}
                          value={title}
                        />
                      </FormItem>
                    </div>
                  </div>
                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-16">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Meta Description</span>}
                      >
                        <TextArea
                          rows={3}
                          placeholder="Meta Description"
                          onChange={handleMetaDescription}
                          value={metaDescription}
                        />
                      </FormItem>
                    </div>

                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}></span>Short Description</span>}
                      >
                        <Input
                          type="text"
                          placeholder="Short Description"
                          value={shortDescription}
                          onChange={handleShortDescription}
                        />
                      </FormItem>
                    </div>
                  </div>

                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                      <div className="ant-row hd-title gx-m-0">
                        <div className="ant-col-md-12">
                          <h1><span style={{ color: "red" }}>*</span>Thumbnail Image</h1>
                        </div>
                      </div>
                      <div className="ant-row gx-mt-4">
                        <div className="ant-col-md-24">
                          <div className="item-detail-edit-box">
                            <div className="ant-row">
                              <div className="ant-col-md-4 upload-img-main">
                                <Upload
                                  listType="picture-card"
                                  fileList={fileList}
                                  onPreview={handlePreview}
                                  customRequest={customRequest}
                                  onChange={handleChange}
                                  onRemove={handleRemove}
                                  accept="image/jpeg, image/png"
                                >
                                  {fileList?.length ? null : uploadButton}
                                </Upload>
                                <Modal
                                  visible={previewVisible}
                                  footer={null}
                                  onCancel={handleCancel}
                                >
                                  <img
                                    alt=""
                                    style={{ width: "100%" }}
                                    src={previewImage}
                                  />
                                </Modal>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ------------------------Content------------------------------------ */}
                  {/* <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                      <ContentForm editFormContents={isEdit ? contentProps : []} />
                    </div>
                  </div> */}
                  {/* ------------------------------------------------------------------- */}

                  {/* ------------------------Content---new--------------------------------- */}
                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                      <ContentsForm editFormContents={isEdit ? contentProps : []} />
                    </div>
                  </div>
                  {/* ------------------------------------------------------------------- */}

                  {/* ------------------------Ads------------------------------------ */}
                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                      <AdsForm editFormContents={isEdit ? adsProps : []} />
                    </div>
                  </div>
                  {/* ------------------------------------------------------------------- */}

                  {/* ------------------------Banners------------------------------------ */}
                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                      <BannersForm
                        editFormContents={isEdit ? bannersProps : []}
                      />
                    </div>
                  </div>
                  {/* ------------------------------------------------------------------- */}

                  {/* ------------------------Printable------------------------------------ */}
                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                      <PrintableForm
                        editFormContents={isEdit ? printableProps : []}
                      />
                    </div>
                  </div>
                  {/* ------------------------------------------------------------------- */}

                  {/* ------------------------Share------------------------------------ */}
                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                      <ShareForm
                        editFormContents={isEdit ? shareProps : []}
                      />
                    </div>
                  </div>
                  {/* ------------------------------------------------------------------- */}

                  {/* ------------------------AdsenseForm------------------------------------ */}
                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                      <AdsenseForm
                        editFormContents={isEdit ? adsenseProps : []}
                      />
                    </div>
                  </div>
                  {/* ------------------------------------------------------------------- */}

                  {/* ------------------------Article------------------------------------ */}
                  {/* <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                      <ArticleForm
                        editFormContents={isEdit ? articleProps : []}
                      />
                    </div>
                  </div> */}
                  {/* ------------------------------------------------------------------- */}

                  {/* ------------------------Teaser------------------------------------ */}
                  {/* <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                      <TeaserForm
                        editFormContents={isEdit ? teaserProps : []}
                      />
                    </div>
                  </div> */}
                  {/* ------------------------------------------------------------------- */}

                </div>
              </div>
            </div>
          </Card>
          <div className="ant-row gx-m-0 btn-right">
            <div className="ant-row gx-m-0 btn-left">
              <Button
                type="danger"
                className="color-white"
                onClick={history.goBack}
              >
                Back
              </Button>
            </div>

            <Button
              type="primary"
              className="color-white"
              onClick={onPreview}
              disabled={!isSave}
            >
              Preview
            </Button>
            
            { !isSave && <span style={{ color: "red" }}>*Preview not available</span> }

            <Button
              type="primary"
              className="color-white"
              onClick={onSubmit}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </Spin>
  );
}

export default ItemForm;